@layer components {
  .layer {
    position: fixed;
    z-index: 30;
    inset: calc(4rem + env(safe-area-inset-top)) max(var(--space-3), env(safe-area-inset-right))
      max(var(--space-3), env(safe-area-inset-bottom))
      max(var(--space-3), env(safe-area-inset-left));
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    place-items: center;
    padding: var(--space-4);
    border: 3px dashed var(--color-action);
    border-radius: var(--radius-sheet);
    background: color-mix(in oklch, var(--color-action), transparent 86%);
    pointer-events: none;
    animation: fade var(--duration-fast) var(--ease-out);

    &[data-target="version"] {
      border-style: solid;
      border-width: 4px;
      background: color-mix(in oklch, var(--color-action), transparent 92%);
    }
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
  }

  .pill {
    display: inline-flex;
    align-items: center;
    gap: var(--space-3);
    min-inline-size: 0;
    max-inline-size: 100%;
    padding: var(--space-3) var(--space-8) var(--space-3) var(--space-3);
    border-radius: var(--radius-full);
    background: var(--color-action);
    color: var(--color-on-action);
    box-shadow:
      inset 0 -5px 0 var(--color-action-shade),
      var(--shadow-lg);
    font-family: var(--font-display);
    font-size: var(--text-xl);
    font-weight: 700;
    line-height: 1.2;
    animation:
      spring-in var(--duration-spring) var(--ease-spring),
      bob 1.6s ease-in-out var(--duration-spring) infinite alternate;

    & span {
      overflow: hidden;
      padding-block: 0.1em;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    & svg {
      flex: none;
      box-sizing: content-box;
      inline-size: 1.5rem;
      block-size: 1.5rem;
      padding: var(--space-3);
      border-radius: 50%;
      background: color-mix(in oklch, var(--color-on-action), transparent 88%);
      stroke-width: 2.25;
    }

    @media (prefers-reduced-motion: reduce) {
      animation: spring-in var(--duration-spring) var(--ease-spring);
    }
  }

  @keyframes spring-in {
    from {
      scale: 0.6;
    }
  }

  @keyframes bob {
    from {
      translate: 0 0;
      rotate: -1.5deg;
    }
    to {
      translate: 0 -0.5rem;
      rotate: 1.5deg;
    }
  }
}
